import React from "react";
import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import certificateOne from "../assets/images/certificate-1.jpg";
import certificateTwo from "../assets/images/certificate-2.jpg";
import certificateThree from "../assets/images/certificate-3.jpg";
import certificateFour from "../assets/images/certificate-4.png";
import certificateFive from "../assets/images/certificate-5.png";
import { useMediaQuery } from "react-responsive";

const Certifications = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 984px)' })

  return (
    <>
      <div className={`container mt-28`}>
        <p className="text-lg mb-10 uppercase tracking-widest text-emerald-600 font-black">
          Certifications
        </p>
        {/* <img src="https://placeimg.com/800/200/arch" className="w-full" /> */}
        <Swiper
        style={isTabletOrMobile ? {width: '70vw'} : {}}
          effect={"cards"}
          grabCursor={true}
          slidesPerView={"auto"}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          modules={[EffectCards]}
          className="mySwiper"
        >
          <SwiperSlide>
            <img src={certificateOne} alt="cert1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={certificateTwo} alt="cert2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={certificateThree} alt="cert3" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={certificateFour} alt="cert4" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={certificateFive} alt="cert5" />
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  );
};

export default Certifications;
